import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Link from 'components/Link';
import AdCaller from 'helpers/ads/adCaller';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import SocialSharingWeb from 'routes/articleshow_v2/components/desktop/SocialSharingWeb';
import SocialSharingMobile from 'routes/articleshow_v2/components/mobile/SocialSharingMobile';
import Loader from 'components/Loader';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import ElementInView from 'components_v2/common/ElementInView';
import ElectionState from './ElectionState';
import Infocus from '../../desktop/Infocus';
import s from './ElectionWidget.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import AlliancePopup from '../../../../../components/ElectionV2/common/AlliancePopup/AlliancePopup';
import LiveblogUpdates from '../../../../../components/ElectionV2/common/LiveblogUpdates/LiveblogUpdates';
import { loadElectionData } from '../../../../../components/ElectionV2/redux';
import SwitchTabs from '../../../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';
import SeatChangeTable from '../../../../../components/ElectionV2/common/SeatChangeTable/SeatChangeTable';
import MiniResultStatus from '../../../../../components/ElectionV2/common/MiniResultStatus/MiniResultStatus';

class ElectionWidget extends React.Component {
  constructor(props) {
    super(props);
    try {
      const { states = [] } = this.props;
      this.state = {
        showAlliancePopup: false,
      };
      this.tabRefs = states.reduce((acc, tab) => {
        acc[tab.key] = React.createRef();
        return acc;
      }, {});
    } catch (error) {
      // Error Occurred
    }
  }

  getSubsetByIndex = (items, index) => {
    let startIndex = index;
    let endIndex = index + 3;
    if (index + 3 > items.length) {
      startIndex = items.length - 3;
      endIndex = items.length;
    }

    const subset = items.slice(startIndex, endIndex);

    return subset;
  };

  componentDidMount() {
    const { isExitPoll, isIframeCssRequired } = this.props;
    if (!isExitPoll) {
      this.props.fetchElectionData();
      this.refreshData();
    }

    if (isIframeCssRequired === true) {
      import('./../../../../../scss_v2/base/_base.scss').then();
      import('./../../../../../components_v2/desktop/Layout/Layout.scss').then();
    }
  }

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.fetchElectionData();
      }, refreshinterval * 1000);
    }
  };

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  setAlliancePopUpData = data => {
    this.setState({
      allianceMap: data,
      showAlliancePopup: !this.state.showAlliancePopup,
    });
    document.body.classList.toggle('disable-scroll');
  };

  toggleAllianceInfoPopup = () => {
    this.setState({ showAlliancePopup: !this.state.showAlliancePopup });
    document.body.classList.toggle('disable-scroll');
  };

  renderTabs = (states, currentActiveTab, isWapView) => {
    const conditionToShow =
      states && isWapView ? states.length > 1 : states.length > 3;

    return (
      conditionToShow && (
        <div className={`${s.tabList} tabList`}>
          {states &&
            states.map((state, index) => (
              <div
                key={state.key}
                onClick={() => {
                  if (!isWapView) {
                    this.changeCricketTabs(
                      this.getSubsetByIndex(states, index),
                    );
                  } else if (isWapView) {
                    this.changeCricketTabs([states[index]]);
                  }
                }}
                ref={this.tabRefs[state.key]}
                className={
                  currentActiveTab &&
                  currentActiveTab.some(obj => obj.key === state.key)
                    ? `${s.tabItem} ${s.active}`
                    : `${s.tabItem}`
                }
              >
                {state.name}
              </div>
            ))}
        </div>
      )
    );
  };

  getBreakingNews = () => {
    const { breakingnews } = this.props;
    if (
      breakingnews &&
      breakingnews[0] &&
      breakingnews[0].path &&
      breakingnews[0].title
    ) {
      return (
        <ElementInView gaAction="Election_Widget_Homepage">
          <h2 className={s.heading}>
            <Link
              to={breakingnews[0].path}
              data-newga={`click-ElectionWidget#${breakingnews[0].path}`}
              target="_blank"
              ga4Data={[
                {
                  event: 'user_click',
                  type: 'exitpoll_widget',
                  label: 'main_widget_title_heading',
                },
              ]}
            >
              {breakingnews[0].title}
            </Link>
          </h2>
        </ElementInView>
      );
    }

    if (
      breakingnews &&
      Array.isArray(breakingnews) &&
      breakingnews.length &&
      breakingnews[0].title
    ) {
      return <h2 className={s.heading}>{breakingnews[0].title}</h2>;
    }
    return <h2 className={s.heading}>Assembly Election 2023</h2>;
  };

  changeCricketTabs = (item, fireEvent = true) => {
    this.setState({ activeTabObject: item }, () => {
      // eslint-disable-next-line no-unused-expressions
      typeof this.props.synctab === 'function' &&
        this.props.synctab(this.state.activeTabObject);
    });
    if (
      item &&
      Array.isArray(item) &&
      item.length &&
      item[0]?.key &&
      this.props.isWapView &&
      this.tabRefs?.[item[0].key]
    ) {
      this.tabRefs[item[0].key].current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }

    if (item && Array.isArray(item) && item.length && fireEvent) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'exitpoll_widget',
        category: 'tab_change',
        label: item.map(i => i.name).join('_') || 'Assembly Elections',
      });
    }
  };

  renderElectionstate = () => {
    const { allianceMap, showAlliancePopup } = this.state;
    let { activeTabObject } = this.state;
    const {
      hideBattle,
      hideStarCandidate,
      hideLiveblog,
      isWapView,
      isIframeCssRequired,
      hideETheading,
      hideLink,
      wgtclient,
      states = [],
      isExitPoll,
      electionData,
      starCandidateData,
      exitPollSourceData,
    } = this.props;

    if (!activeTabObject && !isWapView) {
      activeTabObject = states.slice(0, 3);
    } else if (!activeTabObject && isWapView) {
      activeTabObject = states.slice(0, 1);
    }
    const currentActiveTab = this.props.activeTab || activeTabObject;
    const slideIndex =
      states instanceof Array &&
      states.findIndex(
        st =>
          typeof st !== 'undefined' &&
          currentActiveTab &&
          Array.isArray(currentActiveTab) &&
          currentActiveTab.length > 0 &&
          st.key === currentActiveTab[0].key,
      );
    if (slideIndex > -1 && this.slider) {
      this.slider.slickGoTo(slideIndex);
    }

    if (
      !electionData ||
      typeof electionData !== 'object' ||
      (electionData && Object.keys(electionData).length === 0)
    ) {
      return (
        <div className={s.stateLoading}>
          <Loader />
        </div>
      );
    }
    let slidesToShow = 1;
    let slidesToScroll = 1;
    if (!isWapView && states && Array.isArray(states) && states.length) {
      slidesToShow = states.length >= 3 ? 3 : states.length;
      slidesToScroll = states.length >= 3 ? 3 : states.length;
    }
    const settings = {
      slidesToShow,
      slidesToScroll,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: this.props.showDots || false,
      arrows: false,
      swipeToSlide: false,
      touchMove: !!this.props.ettxt,
      autoplay: false,
      draggable: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
      beforeChange: (current, next) => {
        if (!isWapView) {
          this.changeCricketTabs(
            isWapView ? states[next] : this.getSubsetByIndex(states, next),
            false,
          );
        } else if (isWapView) {
          this.changeCricketTabs([states[next]], false);
        }
      },
    };
    return (
      <>
        {this.renderTabs(states, currentActiveTab, true)}
        <div className={`${s.stateContainer} slick_UI`}>
          <Slider
            className={this.props.showDots ? 'slick_UI' : ''}
            ref={slider => {
              this.slider = slider;
            }}
            {...settings}
          >
            {states &&
              states.length > 0 &&
              states.map(state => (
                <ElectionState
                  key={state.name}
                  isExitPoll={isExitPoll}
                  config={state}
                  data={electionData[state.key]}
                  isWapView={isWapView}
                  setAlliancePopUpData={this.setAlliancePopUpData}
                  sourceData={exitPollSourceData[state.key]}
                  starCandidateData={
                    starCandidateData && starCandidateData[state.key]
                  }
                  hideStarCandidate={hideStarCandidate}
                  hideLiveblog={hideLiveblog}
                  isIframeCssRequired={isIframeCssRequired}
                  hideETheading={hideETheading}
                  hideLink={hideLink}
                  numberOfStates={states.length}
                  hideBattle={hideBattle}
                  wgtclient={wgtclient}
                  infoMsgClass={state.className}
                />
              ))}
          </Slider>
          {isWapView &&
            showAlliancePopup && (
              <PopupPortal usePopupPortal>
                <AlliancePopup
                  allianceMap={allianceMap}
                  toggleAllianceInfoPopup={this.toggleAllianceInfoPopup}
                />
              </PopupPortal>
            )}
        </div>
      </>
    );
  };

  render() {
    const {
      isWapView,
      hideSharing,
      hideLiveblog,
      hideHeading,
      hideInfocus,
      isIframeCssRequired,
      hideETheading,
      isExitPoll,
      bgColor,
      bgColorOuter,
      ettxt,
      liveblog,
      keywords,
      states = [],
      displaytext,
      datasource,
      path,
    } = this.props;
    const backGroundStyle = bgColor ? `#${bgColor}` : '';

    const backGroundStyleOuter = bgColorOuter ? `#${bgColorOuter}` : '';

    return (
      <div className={`${`election_widget`}`} ref={this.ref}>
        <div
          className={`${s.electionWidget} ${
            isIframeCssRequired ? s.iframe : ''
          } ${!isExitPoll ? s.result : ''}`}
          style={{ backgroundColor: backGroundStyleOuter }}
        >
          <div className="flexCenter mb10">
            <SwitchTabs />
          </div>
          <SeatChangeTable />
          <MiniResultStatus />
          <div className={s.electionHeader}>
            {isIframeCssRequired &&
              !hideETheading && (
                <div className={s.ETheader}>
                  <span className={s.ETheading}>
                    {ettxt || displaytext || `Assembly Elections 2023`}
                    {!isExitPoll &&
                      datasource && (
                        <span className={`${s.cvoter}`}>{datasource}</span>
                      )}
                  </span>
                  <span className={s.logo}>
                    <img
                      src="https://static.toiimg.com/photo/82253493.cms"
                      alt=""
                    />
                  </span>
                </div>
              )}

            {((isIframeCssRequired && hideETheading) ||
              !isIframeCssRequired) && (
              <div
                className={`${s.electionTitleWrap} ${
                  this.props.isPowerByAd ? s.titlewithad : ''
                }`}
              >
                <Link
                  to={path}
                  className={s.tagLine}
                  data-newga={`click-ElectionWidget#${path}`}
                  target="_blank"
                  onClick={
                    this.props.hideLink
                      ? e => {
                          e.preventDefault();
                        }
                      : null
                  }
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: 'exitpoll_widget',
                      category: 'Assembly Elections',
                      label: displaytext || `Assembly Elections 2023`,
                    },
                  ]}
                >
                  {ettxt || displaytext || `Assembly Elections 2023`}
                </Link>
                {this.props.isPowerByAd && (
                  <div
                    className={this.props.isPowerByAdActive ? s.pwdByAd : ''}
                  >
                    <AdCaller
                      data={{
                        name: 'electionPowerby',
                        ...this.props.isPowerByAd,
                      }}
                      immediateLoad
                    />
                  </div>
                )}
              </div>
            )}
            {!hideHeading && this.getBreakingNews()}
            {!isWapView &&
              !hideSharing && (
                <div className={`${s.shareWrap}`}>
                  <SocialSharingWeb
                    title="Assembly Elections 2023: Karnataka 2023 Election Dates, Exit polls, Opinion Poll and Results"
                    textRequired={false}
                    url="https://timesofindia.indiatimes.com/elections/assembly-elections"
                    disableShortUrl
                    linkeDin
                    via="@timesofindia"
                    gaAction="Click"
                    gaCategory="Election_Widget_Homepage"
                    topsticky
                    defaultEmailView
                    ga4Data={{
                      event: 'user_click',
                      type: 'exitpoll_widget',
                      category: 'social_media_links',
                    }}
                  />
                </div>
              )}
          </div>
          <div
            style={{ backgroundColor: backGroundStyle }}
            className={s.electionInner}
          >
            {
              <div>
                <div
                  className={`${s.twoColumn} ${
                    states && states.length === 1
                      ? `${s.singleStateElection}`
                      : ''
                  }`}
                >
                  <div className={s.left}>
                    {states && states.length > 0 && this.renderElectionstate()}
                  </div>
                  {!isWapView &&
                    !hideLiveblog && (
                      <div className={`${s.right} boxStyle`}>
                        {states &&
                          liveblog &&
                          !hideLiveblog && (
                            <>
                              <LiveblogUpdates
                                isWapView={isWapView}
                                liveblogData={liveblog}
                                storiesCount={liveblog?.storyCount || 1}
                                ga4Data={[
                                  {
                                    event: 'user_click',
                                    type: 'exitpoll_widget',
                                    label: 'view_more_update',
                                  },
                                ]}
                              />
                            </>
                          )}
                      </div>
                    )}
                </div>
              </div>
            }
            {!isExitPoll &&
              datasource && (
                <span
                  className={`${s.sourceText1} ${
                    isIframeCssRequired && !hideETheading ? s.hide : ''
                  }`}
                >
                  {datasource}
                </span>
              )}
            {keywords &&
              !hideInfocus &&
              Array.isArray(keywords.items) &&
              Array.isArray(keywords.items[0]) && (
                <div className={s.infocus}>
                  <Infocus
                    title={keywords.title}
                    data={keywords.items[0]}
                    ga4Data={{
                      event: 'user_click',
                      type: 'exitpoll_widget',
                    }}
                    secname="Election_Widget_Homepage"
                  />
                </div>
              )}
          </div>
          {this.props.isWapView &&
            isExitPoll &&
            !hideLiveblog &&
            liveblog && (
              <div className={`${s.stateContainer} ${s.liveBlogWrap}`}>
                <LiveblogUpdates
                  isWapView={isWapView}
                  liveblogData={liveblog}
                  storiesCount={1}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: 'exitpoll_widget',
                      label: 'view_more_update',
                    },
                  ]}
                />
              </div>
            )}
          {this.props.isWapView &&
            !hideSharing && (
              <div className="election_share">
                <SocialSharingMobile
                  title="Assembly election 2023: election dates, exit polls, Opinion Poll and Results"
                  whatsAppShow
                  isWapView
                  gaAction="Click"
                  isTablet={false}
                  via="@timesofindia"
                  gaCategory="Election_Widget_Homepage"
                  url="https://timesofindia.indiatimes.com/elections/assembly-elections"
                  wu="https://timesofindia.indiatimes.com/elections/assembly-elections"
                  disableShortUrl
                  ga4Data={{
                    event: 'user_click',
                    type: 'exitpoll_widget',
                    category: 'social_media_links',
                  }}
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.electionV2.refreshinterval,
  electionData: state?.electionV2.electionData,
  starCandidateData: state?.electionV2.starCandidateData,
  isExitPoll: state?.electionV2.isExitPoll,
  displaytext: state?.electionV2.displaytext,
  keywords: state?.electionV2.keywords,
  breakingnews: state?.electionV2.breakingnews,
  states: state?.electionV2.states,
  liveblog: state?.electionV2.liveblog,
  datasource: state?.electionV2.datasource,
  hideexitheading: state?.electionV2.hideexitheading,
  path: state?.electionV2.path,
  exitPollSourceData: state?.electionV2.exitPollSourceData,
});

const mapDispatchToProps = dispatch => ({
  fetchElectionData: () => {
    dispatch(loadElectionData());
  },
});

ElectionWidget.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  isExitPoll: PropTypes.bool,
  isIframeCssRequired: PropTypes.bool,
  hideETheading: PropTypes.bool,
  hideExitHeading: PropTypes.bool,
  bgColor: PropTypes.string,
  bgColorOuter: PropTypes.string,
  isPowerByAd: PropTypes.shape({}),
  isPowerByAdActive: PropTypes.number,
  showDots: PropTypes.bool,
  ettxt: PropTypes.string,
};
ElectionWidget.defaultProps = {
  isWapView: false,
  data: {},
  isExitPoll: false,
  isIframeCssRequired: false,
  hideETheading: false,
  hideExitHeading: false,
  bgColor: '',
  bgColorOuter: '',
  isPowerByAd: null,
  isPowerByAdActive: 0,
  showDots: false,
  ettxt: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(ElectionWidget);
